import { render, staticRenderFns } from "./selectCertificate.vue?vue&type=template&id=2c6e9759&"
import script from "./selectCertificate.vue?vue&type=script&lang=js&"
export * from "./selectCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports